import React from "react"
import { View } from "react-native"
import { theme } from "../../theme/theme"
import TouchableRippleM from "../button/TouchableRippleM"
import TextM from "../text/TextM"
import AvatarM from "./AvatarM"

const AvatarGroupM = ({ users = [], size = 32, onPress, style }) => {
    const displayUsers = users.slice(0, 2)
    const extraCount = users.length - displayUsers.length

    return (
        <TouchableRippleM
            onPress={onPress}
            style={[{ flexDirection: "row", alignItems: "center" }, style]}
        >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                {displayUsers.map((user, index) => (
                    <AvatarM
                        key={index}
                        user={user}
                        size={size}
                        style={{
                            marginLeft: index === 0 ? 0 : -size / 2,
                            zIndex: index + 1,
                        }}
                    />
                ))}
                {extraCount > 0 && (
                    <View
                        style={{
                            marginLeft: -size / 2,
                            width: size,
                            height: size,
                            borderRadius: size / 2,
                            backgroundColor: theme.colors.lightMore,
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: displayUsers.length + 1,
                        }}
                    >
                        <TextM fontSize={size / 2} fontWeight="semibold">
                            +{extraCount}
                        </TextM>
                    </View>
                )}
            </View>
        </TouchableRippleM>
    )
}

export default AvatarGroupM
